import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-tarifas',
  templateUrl: './page-tarifas.component.html',
  styleUrls: ['./page-tarifas.component.scss']
})
export class PageTarifasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.scroll(0,0);
  }

}
